// extracted by mini-css-extract-plugin
module.exports = {"styledLink":"_1gpUt","StyledBodylink":"jEgmf","greyLink":"_2B6FN","charcoalLink":"_3Xo2P","fullWidth":"KCtII","withArrow":"_1_Nnu"};